export const studentInfoInitialValues = {
  info: {
    firstName: "",
    lastName: "",
    identificationNumber: "",
    birthDate: null,
    birthPlace: '',
    idNumber: ''
  }
}